module.exports = __webpack_public_path__ + "static/media/card-1.ee93a253.svg";